export default "__VITE_ASSET__DYtE1$lz__"